import { render, staticRenderFns } from "./VesselInfo.vue?vue&type=template&id=8f87f1f2&"
import script from "./VesselInfo.vue?vue&type=script&lang=ts&"
export * from "./VesselInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports